import styled from 'styled-components';

export const UploadAttachmentButton = styled.button`
    border: 0;
    outline: none;
    cursor: pointer;
    background: none;
    color: ${({ theme }) => theme.colors.clientCharts.customer};
`;

export const UploadText = styled.span`
    font-style: normal;
    font-weight: normal;
    text-align: center;
    color: ${({ theme }) => theme.colors.tangerine};
    cursor:pointer;
    font-size: 13px;
    line-height: 22px;
    pointer-events: none;
`;




// WEBPACK FOOTER //
// ./src/components/attachments/header/upload-attachments/styled-components.js